import type { TranslationKey } from '@/lib/i18n';

export const CART_SUMMARY_SUBTOTAL = [
  'sidecart:cart.subtotal',
  'Order Subtotal:',
] as const satisfies TranslationKey;

export const CART_SUMMARY_SAVINGS_LABEL = [
  'sidecart:cart.savingsLabel',
  "YOU'RE SAVING",
] as const satisfies TranslationKey;

export const CART_SUMMARY_CHECKOUT = [
  'sidecart:cart.checkout',
  'PROCEED TO CHECKOUT',
] as const satisfies TranslationKey;

export const CART_FREE_SHIPPING_UNLOCKED = [
  'sidecart:cart.freeShipping.unlocked',
  "Congrats! You've unlocked <strong>FREE SHIPPING!</strong>",
] as const satisfies TranslationKey;

export const CART_FREE_SHIPPING_PROGRESS_PREFIX = [
  'sidecart:cart.freeShipping.progressPrefix',
  "You're",
] as const satisfies TranslationKey;

export const CART_FREE_SHIPPING_PROGRESS_SUFFIX = [
  'sidecart:cart.freeShipping.progressSuffix',
  'away from',
] as const satisfies TranslationKey;

export const CART_FREE_SHIPPING_PROGRESS_LABEL = [
  'sidecart:cart.freeShipping.progressLabel',
  'FREE SHIPPING!',
] as const satisfies TranslationKey;

export const CART_CREDITS_UNLOCKED = [
  'sidecart:cart.credits.unlocked',
  'Your <strong>{{balance}}</strong> in credits is unlocked — use it at checkout!',
] as const satisfies TranslationKey;

export const CART_CREDITS_PROGRESS_PREFIX = [
  'sidecart:cart.credits.progressPrefix',
  'Spend',
] as const satisfies TranslationKey;

export const CART_CREDITS_PROGRESS_SUFFIX = [
  'sidecart:cart.credits.progressSuffix',
  'more to unlock your',
] as const satisfies TranslationKey;

export const CART_CREDITS_PROGRESS_LABEL = [
  'sidecart:cart.credits.progressLabel',
  'store credits!',
] as const satisfies TranslationKey;
